export default {
  title: {
    notes: 'Title of checkout dialog',
    message: 'Checkout',
  },
  step1: {
    name: {
      notes:
        'Name of step 1 in checkout dialog where content of products to checkout is listed',
      message: 'Contents',
    },
  },
  step2: {
    name: {
      notes:
        'Name of step 2 in checkout dialog where order information details are entered',
      message: 'Order information',
    },
  },
  step3: {
    name: {
      notes:
        'Name of step 3 in checkout dialog where shipping and invoice information is displayed',
      message: 'Shipping & invoicing',
    },
  },
  step4: {
    name: {
      notes: 'Name of step 4 in checkout dialog which contains a summary',
      message: 'Summary',
    },
    itemHeader: {
      notes: 'Header above table listing products about to be checked out',
      message: 'Items',
    },
    terms: {
      text: {
        notes:
          'Text next to checkbox describing that user needs to agree to terms and condition in order to submit order without the text "terms and condition".',
        message: 'I have read and understood the',
      },
      link: {
        notes: 'Text for link to terms and conditions',
        message: 'terms and conditions',
      },
      validation: {
        mustAgreeToTerms: {
          notes:
            'Text displayed when user is trying to checkout without agreeing to terms and conditions',
          message:
            'You must agree to the terms and conditions before you submit the order.',
        },
      },
    },
  },
  action: {
    prev: {
      notes: 'Text on button going to previous step in dialog',
      message: 'Prev',
    },
    next: {
      notes: 'Text on button going to next step in dialog',
      message: 'Next',
    },
    cancel: {
      notes: 'Text on button cancelling the dialog',
      message: 'Cancel',
      continueCheckout: {
        notes:
          'Text on confirm button option when aborting the cancel operation',
        message: 'Continue checkout',
      },
      confirm: {
        notes: 'Text on confirm button option before closing dialog',
        message: 'Cancel checkout',
      },
    },
    submit: {
      notes: 'Text on button submitting the checkout',
      message: 'Submit order',
    },
  },
  model: {
    confirmationEmailAddresses: {
      notes: 'Label of confirmation email address field',
      message: 'Confirmation e-mail addresses',
      error: {
        noValue: {
          notes: 'When no e-mail address is entered',
          message: 'Enter an e-mail address to add',
        },
        invalidFormat: {
          notes: 'When e-mail address is on invalid format',
          message: 'Invalid e-mail address format',
        },
        exists: {
          notes: 'When e-mail address already exists in the list',
          message: 'The e-mail address is already in the list',
        },
      },
      action: {
        addRow: {
          text: {
            notes:
              'Text on button to add a new field where e-mail address is entered',
            message: 'Add e-mail address',
          },
        },
        add: {
          ariaLabel: { notes: 'Aria-label of add button', message: 'Add' },
        },
        delete: {
          ariaLabel: {
            notes: 'Aria-label of delete button',
            message: 'Delete',
          },
        },
      },
    },
    deliveryPoint: {
      notes: 'Label of delivery address (a.k.a. delivery point) field',
      message: 'Delivery address',
      validation: {
        required: {
          notes: 'Validation message when no delivery address is selected',
          message: 'Delivery address is required',
        },
      },
    },
    deliveryDate: {
      notes: 'Label for Estimated delivery date',
      message: 'Estimated delivery date',
    },
    invoiceAddress: {
      notes: 'Label of invoicing address field',
      message: 'Invoicing address',
    },
    orderCriticality: {
      notes: 'Label for order criticality field',
      message: 'Order criticality',
      validation: {
        required: {
          notes: 'Validation message when no order criticality is entered',
          message: 'Order criticality is required',
        },
      },
    },
    orderNotes: {
      notes: 'Label for order notes field',
      message: 'Order notes',
    },
    referenceNumber: {
      notes: 'Label for reference number field',
      message: 'Reference number',
      validation: {
        required: {
          notes: 'Validation message when no reference number is entered',
          message: 'Reference number is required',
        },
        maxLength: {
          notes: 'Validation message when the reference number is to long.',
          message: 'Reference number must not exceed {{maxLength}} characters',
        },
      },
    },
    requestedDeliveryDate: {
      notes: 'Label for requested delivery date field',
      message: 'Requested delivery date',
      validation: {
        required: {
          notes:
            'Validation message when no requested delivery date is entered',
          message: 'Requested delivery date is required',
        },
      },
    },
    shipmentControl: {
      notes:
        'Label for shipment control field (partial / complete line / complete / ...)',
      message: 'Delivery option',
      validation: {
        required: {
          notes: 'Validation message when no shipment control is entered',
          message: 'Delivery option is required',
        },
      },
    },
  },
  checkoutButton: {
    text: {
      notes: 'Text on checkout button',
      message: 'Checkout',
    },
    priceMissingTooltip: {
      notes:
        'Tooltip when checkout button is disabled due to missing price on items',
      message: 'Unable to checkout as some articles are missing price',
    },
    punchoutButton: {
      notes: 'Text on punchout button',
      message: 'Punchout',
    },
  },
  notification: {
    orderSubmitSuccess: {
      notes: 'Notification message when order is successfully sent',
      message: 'Thank you for your order!',
    },
    orderSubmitError: {
      notes: 'Notification message when the submitting the order failed',
      message: 'Failed to send order: {{errorMessage}}',
    },
  },
};
